<div>
  <app-image
    *ngIf="avatarPath"
    [path]="avatarPath"
    [height]="height"
    [width]="width"
    alt="avatar">
  </app-image>
</div>
